 /**
 * Created by Shiv Roy on 21/11/17.
 */
import { showFormatedDate, showFormattedTime, base64Encode, showFormatedDateandTime } from '../../../../actions/utilAction';
import classNames from 'classnames';
import { renderTextArea, renderCheckBox, renderTextField, renderTimePicker, renderCustomRadioButtons, isInteger } from '../../../../components/reduxFields';
import { Field, reduxForm, formValueSelector } from 'redux-form';
import { CommonButton } from '../../../../components/buttons';
import { connect } from 'react-redux';
// import PatientInfo from '../../patient_info';
import React from 'react';
import history from '../../../../history';
import moment from 'moment';

import {
  Table,
  TableBody,
  TableHeader,
  TableHeaderColumn,
  TableRow,
} from 'material-ui/Table';

import { getPatientSingleEncounters } from '../../actions/PatientActions';

class EncounterForm extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      apptid: props.match.params.apptid,
      encid: props.match.params.id,
      patientId: null,
      appointmentTypeName: '',
      appointmentDate: null,
      appointmentTime: null,
      staffName: '',
      serviceFacility: '',
      isDirectService: false,
      PatientLocationName: '',
      EmployeeSign: { Bytes: '', Date: null, Name: '', Latitude: 0.0, Longitude: 0.0 },
      ClientSign: { Bytes: '', Date: null, Name: '', Latitude: 0.0, Longitude: 0.0 },
      GuardianSign: { Bytes: '', Date: null, Name: '', Latitude: 0.0, Longitude: 0.0 },
      RenderingProviderSign: { Bytes: '', Date: null, Name: '', Latitude: 0.0, Longitude: 0.0 },
    };
    this.handleBackClick = this.handleBackClick.bind(this);
  }

  componentWillMount() {
    let searchObj = {
      'apptId': this.state.apptid,
      'encounterId': this.state.encid,
    };
    this.props.getPatientSingleEncounters(searchObj);
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.singleEncounter && this.props.singleEncounter !== nextProps.singleEncounter) {
      let appointmentData = nextProps.singleEncounter.patientAppointment;
      if (appointmentData) {
        let staffNames = [];
        appointmentData.appointmentSingleStaff.forEach((staff) => {
          staffNames.push(staff.staffName);
        });
        this.setState({
          patientId: appointmentData.patientID,
          appointmentTypeName: appointmentData.appointmentTypeName,
          appointmentDate: showFormatedDate(appointmentData.startDateTime),
          appointmentTime: showFormattedTime(appointmentData.startDateTime) + ' - ' + showFormattedTime(appointmentData.endDateTime),
          staffName: staffNames && staffNames ? staffNames.join(',') : '',
          serviceFacility: appointmentData.serviceFacility,
          isDirectService: appointmentData.isDirectService,
          PatientLocationName: appointmentData.address,
        });

        let soapObj = nextProps.singleEncounter;
        let guardianSignObj = {}, clientSignObj = {}, employeeSignObj = {}, renderingProviderSignObj = {};
        if (soapObj.encounterSignature) {
          (soapObj.encounterSignature || []).forEach((signObj) => {
            if (signObj.guardianSign) {
              let data = {
                Bytes: signObj.guardianSign,
                Date: signObj.guardianSignDate,
                Name: signObj.guardianName,
                Latitude: signObj.latitude, 
                Longitude: signObj.longitude,
              };
              guardianSignObj = data;
            }
            if (signObj.patientSign) {
              let data = {
                Bytes: signObj.patientSign,
                Date: signObj.patientSignDate,
                Name: nextProps.singleEncounter.patientName,
                Latitude: signObj.latitude, 
                Longitude: signObj.longitude,
              };
              clientSignObj = data;
            }
            if (signObj.clinicianSign) {
              let data = {
                Bytes: signObj.clinicianSign,
                Date: signObj.clinicianSignDate,
                Name: staffNames && staffNames ? staffNames.join(',') : '',
                Latitude: signObj.latitude, 
                Longitude: signObj.longitude,
              };
              employeeSignObj = data;
            }
            if (signObj.renderingProviderSign) {
              let data = {
                Bytes: signObj.renderingProviderSign,
                Date: signObj.renderingProviderSignDate,
                Name: signObj.renderingProviderName,
                Latitude: signObj.latitude,
                Longitude: signObj.longitude,
              };
              renderingProviderSignObj = data;
            }
          });
        }
        this.setState({
          ClientSign: clientSignObj,
          GuardianSign: guardianSignObj,
          EmployeeSign: employeeSignObj,
          RenderingProviderSign: renderingProviderSignObj,
        });
      }
    }
  }

  renderDiagnosis() {
    if (this.props.initialValues.diagnosisArray && this.props.initialValues.diagnosisArray.length === 0) {
      return (
        <tr><td className="text-center no-record">No record found.</td></tr>
      );
    } else {
      if (this.props.initialValues.diagnosisArray && this.props.initialValues.diagnosisArray.length !== 0) {
        return this.props.initialValues.diagnosisArray.map((diagnosis, index) => {
          if (diagnosis.IsDeleted) {
            return <tr key={index}><td colSpan='3'><span className='redfont'>{diagnosis.description}</span></td></tr>;
          }
          return (
            <tr key={index}>
              <td width="30%">{diagnosis.icdCode}</td>
              <td width="70%">{diagnosis.description ? diagnosis.description : ''}</td>
              {/* <td width="10%"><button onClick={(e) => this.handleRemoveDiagnosisClick(e, index)} title="Remove" type="button" className="tbactionbtn redfont">Remove</button></td>*/}
            </tr>
          );
        });
      }
    }
  }


  renderCpt() {
    if (this.props.initialValues.CPTTableData && this.props.initialValues.CPTTableData.length === 0) {
      return (
        <tr><td className="text-center no-record">No record found.</td></tr>
      );
    } else if (this.props.initialValues.CPTTableData && this.props.initialValues.CPTTableData.length !== 0) {
      return this.props.initialValues.CPTTableData.map((cpt, index) => {
        if (cpt.IsDeleted) {
          return <tr key={index}><td colSpan='3'><span className='redfont'>{cpt.serviceCode}</span></td></tr>;
        }
        return (
          <tr key={index}>
            <td width="20%">{cpt.serviceCode ? cpt.serviceCode : '-'}</td>
            <td width="30%">{cpt.attachedModifiers ? cpt.attachedModifiers : '-'}</td>
            <td width="50%">{cpt.description ? cpt.description : '-'}</td>
          </tr>
        );
      });
    }
  }

  handleBackClick = () => {
    let encPatientId = this.state.patientId ? base64Encode(`${this.state.patientId}`) : null;
    if (this.props.location.state && this.props.location.state.isRedirectFromPatientEncounter && encPatientId) {
      history.push(`/client/encounter/${encPatientId}`);
    } else {
      history.push('/dashboard');
    }
  };

  render() {
    const tableClass1 = classNames({
      'table': true,
      'customtable': true,
      'fixedheader': true,
      'table-hover': true,
    });

    let totalUnitsConsumed = (this.props.singleEncounter && this.props.singleEncounter.unitsConsumed) || 0;

    return (
      <div>
        {/* <h2 className="page_title">Client Encounter</h2>
        <PatientInfo patientId={this.state.patientid} />
        <div className="clearfix"></div> */}
        <div className="readmin-panel">
          <div className="panel-body">
            <form className="readmin-form custom_form">
              <div className="row">
                <div className="col-sm-12">
                  <div className="panel_title no_margin mb-20">
                    <CommonButton label="Back" primary={true} onTouchTap={this.handleBackClick} />
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-sm-12">
                  <div className="panel_title no_margin mb-20">
                    <h3>Appointment</h3>
                    <i className="flaticon flaticon-medical-4"></i>
                  </div>
                </div>
                <div className="col-sm-12 ml-20">
                  <div className="col-sm-12 soap_content">
                    <div className="soap_detail detail_wd">
                      <p>
                        <b>Appointment :</b> <span>{this.state.appointmentTypeName ? this.state.appointmentTypeName : '-'}</span>
                      </p>
                      <p>
                        <b>Appointment Date :</b> <span>{this.state.appointmentDate ? this.state.appointmentDate : '-'}</span>
                      </p>
                      <p>
                        <b>Appointment Time:</b> <span>{this.state.appointmentTime ? this.state.appointmentTime : '-'}</span>
                      </p>
                      <p>
                        <b>Seen By :</b> <span>{this.state.staffName ? this.state.staffName : '-'}</span>
                      </p>
                      {/* <p>
                        <b>Location Type :</b> <span>{this.state.serviceFacility || '-'}</span>
                      </p> */}
                      <p>
                        <b>Service Type :</b> <span>{this.state.isDirectService ? 'Direct' : 'Indirect'}</span>
                      </p>
                      <p>
                        <b>Service Location :</b> <span>{this.state.PatientLocationName ? this.state.PatientLocationName : '-'}</span>
                      </p>
                      <p>
                        <b>Unit Billed :</b> <span>{totalUnitsConsumed}</span>
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              <div className="clearfix"></div>
              <div className="row">
                <div className="col-sm-12">
                  <div className="panel_title">
                    <h3>Service</h3>
                    <i className="flaticon flaticon-time-1"></i>
                  </div>
                </div>
                <div className="col-sm-6">
                  <Field
                    name="serviceStartTime"
                    placeholder="Start Time"
                    disabled={true}
                    fullWidth={true}
                    component={renderTimePicker}
                    selected={this.props.initialValues.serviceStartTime}
                    onDateChange={this.onDateChange}

                  />
                </div>
                <div className="col-sm-6">
                  <Field
                    name="serviceEndTime"
                    placeholder="End Time"
                    component={renderTimePicker}
                    selected={this.props.initialValues.serviceEndTime}
                    onDateChange={this.onDateChange}
                    disabled={true}
                    fullWidth={true}
                  />
                </div>
              </div>
              <div className ="row">
                <div className="col-sm-12">
                  <div className="panel_title">
                    <h3>Progress Notes</h3>
                    <i className="flaticon flaticon-interface-2"></i>
                  </div>
                </div>                            
              </div>

              
              <div className="row">
                <div className="col-sm-12">
                  <div className="panel_title">
                    <h5>Parent report/ observation upon arrival</h5><span style={{ color: 'red'}}>*</span>                    
                  </div>
                </div>
              </div>
              <div className="row">
                <div className='col-sm-3 mt-35'>
                  <Field
                    name="Happy"
                    label="Happy"
                    disabled={true}
                    component={renderCheckBox}
                  />
                </div>
                <div className='col-sm-3 mt-35'>
                  <Field
                    name="Tired"
                    label="Tired"
                    disabled={true}
                    component={renderCheckBox}
                  />
                </div>
                <div className='col-sm-3 mt-35'>
                  <Field
                    name="Sick"
                    label="Sick"
                    disabled={true}
                    component={renderCheckBox}
                  />
                </div>
                <div className='col-sm-3 mt-35'>
                  <Field
                    name="Wellrested"
                    label="Well rested"
                    disabled={true}
                    component={renderCheckBox}
                  />
                </div>
                <div className='col-sm-3 mt-35'>
                  <Field
                    name="Sensorysicking"
                    label="Sensory seeking"
                    disabled={true}
                    component={renderCheckBox}
                  />
                </div>
                <div className='col-sm-3 mt-35'>
                  <Field
                    name="Upset"
                    label="Upset"
                    disabled={true}
                    component={renderCheckBox}
                  />
                </div>
                <div className='col-sm-3 mt-35'>
                  <Field
                    name="OtherPN"
                    label="Other"
                    disabled={true}
                    component={renderCheckBox}
                  />
                </div>
                {this.props.selectorOtherPN &&
                  (<div className='col-sm-3 require'>
                  <Field
                    name="OtherPNNotes"
                    type="text"
                    fullWidth={true}
                    label="Other Notes"
                    disabled={true}
                    component={renderTextField}
                  />
                </div>)}
              </div>
              <div className="row">
                <div className='col-sm-12 mt-35'>
                  <div className="panel_title no_margin mb-20 require">
                    <h5>In a state that warrants therapy?</h5>
                  </div>
                  <Field name="IsWarrantTherapy"
                    options={[{ id: 1, value: 'Yes' }, { id: 0, value: 'No' }]}
                    selectedValue={this.props.IsWarrantTherapy}
                    onChange={this.changeIsWarrantTherapy}
                    disabled={true}
                    component={renderCustomRadioButtons} />
                </div>
              </div>
              <div className="row">
                <div className="col-sm-12">
                  <div className="panel_title">
                    <h5>Symptoms observed during session</h5><span style={{ color: 'red' }}>*</span>                    
                  </div>
                </div>
              </div>
              <div className="row mt-35">               
                <div className="col-sm-12"><h6><strong>Skill Deficits</strong></h6></div>               
              </div>
              <div className="row">
                <div className='col-sm-4 mt-35'>
                  <Field
                    name="SkillDeftReceptiveLanguage"
                    label="Deficits in receptive language"
                    disabled={true}
                    component={renderCheckBox}
                  />
                </div>
                <div className='col-sm-4 mt-35'>
                  <Field
                    name="SkillDeftAdaptiveBehavior"
                    label="Deficits in adaptive behavior"
                    disabled={true}
                    component={renderCheckBox}
                  />
                </div>
                <div className='col-sm-4 mt-35'>
                  <Field
                    name="SkillDeftExpressiveLanguage"
                    label="Deficits in expressive language"
                    disabled={true}
                    component={renderCheckBox}
                  />
                </div>
                <div className='col-sm-4 mt-35'>
                  <Field
                    name="SkillDeftImitationSkills"
                    label="Deficits in imitation skills"
                    disabled={true}
                    component={renderCheckBox}
                  />
                </div>
                <div className='col-sm-4 mt-35'>
                  <Field
                    name="SkillDeftSocialSkills"
                    label="Deficits in social skills"
                    disabled={true}
                    component={renderCheckBox}
                  />
                </div>
                <div className='col-sm-4 mt-35'>
                  <Field
                    name="SkillDeftCommunitySafetySkills"
                    label="Deficits in community safety skills"
                    disabled={true}
                    component={renderCheckBox}
                  />
                </div>
                <div className='col-sm-4 mt-35'>
                  <Field
                    name="SkillDeftPlaySkills"
                    label="Deficits in play skills"
                    disabled={true}
                    component={renderCheckBox}
                  />
                </div>
                <div className='col-sm-4 mt-35'>
                  <Field
                    name="SkillDeftOther"
                    label="Other"
                    disabled={true}
                    component={renderCheckBox}
                  />
                </div>
                {this.props.selectorSkillDeftOther &&
                (<div className='col-sm-4 require'>
                  <Field
                    name="SkillDeftOtherNotes"
                    type="text"
                    fullWidth={true}
                    label="Other Notes"
                    disabled={true}
                    component={renderTextField}
                  />
                </div>)}
                </div>

              <div className="row mt-35">               
                <div className="col-sm-12"><h6><strong>Techniques to increase target behaviors</strong></h6></div>            
              </div>
              <div className="row">
                <div className='col-sm-4 mt-35'>
                  <Field
                    name="TechBehSampling"
                    label="Sampling/Preference Assessment/Pairing"
                    disabled={true}
                    component={renderCheckBox}
                  />
                </div>
                <div className='col-sm-4 mt-35'>
                  <Field
                    name="TechBehBehavioralSkillsTraining"
                    label="Behavioral skills training"
                    disabled={true}
                    component={renderCheckBox}
                  />
                </div>
                <div className='col-sm-4 mt-35'>
                  <Field
                    name="TechBehDTT"
                    label="DTT"
                    disabled={true}
                    component={renderCheckBox}
                  />
                </div>
                <div className='col-sm-4 mt-35'>
                  <Field
                    name="TechBehShaping"
                    label="Chaining/Shaping"
                    disabled={true}
                    component={renderCheckBox}
                  />
                </div>
                <div className='col-sm-4 mt-35'>
                  <Field
                    name="TechBehErrorlessTeaching"
                    label="Errorless Teaching"
                    disabled={true}
                    component={renderCheckBox}
                  />
                </div>
                <div className='col-sm-4 mt-35'>
                  <Field
                    name="TechBehSystematicPromptFading"
                    label="Systematic prompt fading"
                    disabled={true}
                    component={renderCheckBox}
                  />
                </div>
                <div className='col-sm-4 mt-35'>
                  <Field
                    name="TechBehNET"
                    label="NET"
                    disabled={true}
                    component={renderCheckBox}
                  />
                </div>                
                <div className='col-sm-4 mt-35'>
                  <Field
                    name="TechBehOther"
                    label="Other"
                    disabled={true}
                    component={renderCheckBox}
                  />
                </div>
                {this.props.selectorTechBehOther &&
                (<div className='col-sm-4 require'>
                  <Field
                    name="TechBehOtherNotes"
                    type="text"
                    fullWidth={true}
                    label="Other Notes"
                    disabled={true}
                    component={renderTextField}
                  />
                </div>)}
              </div>

              <div className="row">
                <div className="col-sm-12">
                  <div className="panel_title">
                    <h5>Progress towards treatment goals</h5><span style={{ color: 'red' }}>*</span>                    
                  </div>
                </div>
              </div>
              <div className="row">
                <div className='col-sm-4 require'>
                  <Field
                    name="SessionComments1"
                    type="text"
                    fullWidth={true}
                    label="Programs observed during session"
                    disabled={true}
                    component={renderTextField}
                  />
                </div>
                <div className='col-sm-4 mt-35'>
                  <Field
                    name="SessionMastery1"
                    label="Session mastery"
                    disabled={true}
                    component={renderCheckBox}
                  />
                </div>
                <div className='col-sm-4 mt-35'>
                  <Field
                    name="ContinueTeaching1"
                    label="Continue teaching"
                    disabled={true}
                    component={renderCheckBox}
                  />
                </div>
                <div className='col-sm-4 mt-35'>
                  <Field
                    name="Generalized1"
                    label="Generalized"
                    disabled={true}
                    component={renderCheckBox}
                  />
                </div>
                <div className='col-sm-4 mt-35'>
                  <Field
                    name="Hold1"
                    label="Hold/discontinue"
                    disabled={true}
                    component={renderCheckBox}
                  />
                </div>
                <div className='col-sm-4 mt-35'>
                  <Field
                    name="DevelopProtocol1"
                    label="Develop/edit protocol"
                    disabled={true}
                    component={renderCheckBox}
                  />
                </div>                
                <div className='col-sm-4 mt-35'>
                  <Field
                    name="OtherTG1"
                    label="Other"
                    disabled={true}
                    component={renderCheckBox}
                  />
                </div>
                {this.props.selectorOtherTG1 &&
                (<div className='col-sm-4 require'>
                  <Field
                    name="OtherTGNotes1"
                    type="text"
                    fullWidth={true}
                    label="Other Notes"
                    disabled={true}
                    component={renderTextField}
                  />
                </div>)}
              </div>

              <div className="row">
                <div className='col-sm-4 require'>
                  <Field
                    name="SessionComments2"
                    type="text"
                    fullWidth={true}
                    label="Programs observed during session"
                    disabled={true}
                    component={renderTextField}
                  />
                </div>
                <div className='col-sm-4 mt-35'>
                  <Field
                    name="SessionMastery2"
                    label="Session mastery"
                    disabled={true}
                    component={renderCheckBox}
                  />
                </div>
                <div className='col-sm-4 mt-35'>
                  <Field
                    name="ContinueTeaching2"
                    label="Continue teaching"
                    disabled={true}
                    component={renderCheckBox}
                  />
                </div>
                <div className='col-sm-4 mt-35'>
                  <Field
                    name="Generalized2"
                    label="Generalized"
                    disabled={true}
                    component={renderCheckBox}
                  />
                </div>
                <div className='col-sm-4 mt-35'>
                  <Field
                    name="Hold2"
                    label="Hold/discontinue"
                    disabled={true}
                    component={renderCheckBox}
                  />
                </div>
                <div className='col-sm-4 mt-35'>
                  <Field
                    name="DevelopProtocol2"
                    label="Develop/edit protocol"
                    disabled={true}
                    component={renderCheckBox}
                  />
                </div>                
                <div className='col-sm-4 mt-35'>
                  <Field
                    name="OtherTG2"
                    label="Other"
                    disabled={true}
                    component={renderCheckBox}
                  />
                </div>
                {this.props.selectorOtherTG2 &&
                (<div className='col-sm-4 require'>
                  <Field
                    name="OtherTGNotes2"
                    type="text"
                    fullWidth={true}
                    label="Other Notes"
                    disabled={true}
                    component={renderTextField}
                  />
                </div>)}
              </div>

              <div className="row">
                <div className='col-sm-4 require'>
                  <Field
                    name="SessionComments3"
                    type="text"
                    fullWidth={true}
                    label="Programs observed during session"
                    disabled={true}
                    component={renderTextField}
                  />
                </div>
                <div className='col-sm-4 mt-35'>
                  <Field
                    name="SessionMastery3"
                    label="Session mastery"
                    disabled={true}
                    component={renderCheckBox}
                  />
                </div>
                <div className='col-sm-4 mt-35'>
                  <Field
                    name="ContinueTeaching3"
                    label="Continue teaching"
                    disabled={true}
                    component={renderCheckBox}
                  />
                </div>
                <div className='col-sm-4 mt-35'>
                  <Field
                    name="Generalized3"
                    label="Generalized"
                    disabled={true}
                    component={renderCheckBox}
                  />
                </div>
                <div className='col-sm-4 mt-35'>
                  <Field
                    name="Hold3"
                    label="Hold/discontinue"
                    disabled={true}
                    component={renderCheckBox}
                  />
                </div>
                <div className='col-sm-4 mt-35'>
                  <Field
                    name="DevelopProtocol3"
                    label="Develop/edit protocol"
                    disabled={true}
                    component={renderCheckBox}
                  />
                </div>                
                <div className='col-sm-4 mt-35'>
                  <Field
                    name="OtherTG3"
                    label="Other"
                    disabled={true}
                    component={renderCheckBox}
                  />
                </div>
                {this.props.selectorOtherTG3 &&
                (<div className='col-sm-4 require'>
                  <Field
                    name="OtherTGNotes3"
                    type="text"
                    fullWidth={true}
                    label="Other Notes"
                    disabled={true}
                    component={renderTextField}
                  />
                </div>)}
              </div>


              <div className="row">
                <div className="col-sm-12">
                  <div className="panel_title">
                    <h5>Generalization/Maintenance</h5><span style={{ color: 'red' }}>*</span>                    
                  </div>
                </div>
              </div>
              <div className="row mt-35">               
                <div className="col-sm-12"><h6><strong>Generalization and Maintenance Checks</strong></h6></div>            
              </div>
              <div className="row">                
                <div className='col-sm-4 mt-35'>
                  <Field
                    name="GenReceptiveLanguage"
                    label="Receptive Language"
                    disabled={true}
                    component={renderCheckBox}
                  />
                </div>
                <div className='col-sm-4 mt-35'>
                  <Field
                    name="GenPlay"
                    label="Play"
                    disabled={true}
                    component={renderCheckBox}
                  />
                </div>
                <div className='col-sm-4 mt-35'>
                  <Field
                    name="GenExpressiveLanguage"
                    label="Expressive Language"
                    disabled={true}
                    component={renderCheckBox}
                  />
                </div>
                <div className='col-sm-4 mt-35'>
                  <Field
                    name="GenFCT"
                    label="FCT"
                    disabled={true}
                    component={renderCheckBox}
                  />
                </div>
                <div className='col-sm-4 mt-35'>
                  <Field
                    name="GenImitation"
                    label="Imitation"
                    disabled={true}
                    component={renderCheckBox}
                  />
                </div>     
                <div className='col-sm-4 mt-35'>
                  <Field
                    name="GenAdaptiveBehavior"
                    label="Adaptive Behavior"
                    disabled={true}
                    component={renderCheckBox}
                  />
                </div>                
                <div className='col-sm-4 mt-35'>
                  <Field
                    name="GenOther"
                    label="Other"
                    disabled={true}
                    component={renderCheckBox}
                  />
                </div>
                {this.props.selectorGenOther &&
                (<div className='col-sm-4 require'>
                  <Field
                    name="GenOtherNotes"
                    type="text"
                    fullWidth={true}
                    label="Other Notes"
                    disabled={true}
                    component={renderTextField}
                  />
                </div>)}
              </div>
              
              <div className="row">
                <div className='col-sm-4 require'>
                  <Field
                    name="TotalNumberOfTrials"
                    type="text"
                    fullWidth={true}
                    label="Total # of trials/session"
                    maxLength='14'
                    disabled={true}
                    component={renderTextField}
                    normalize={isInteger}
                  />
                </div>
              </div>

              <div className="row mt-35">               
                <div className="col-sm-12"><h6><strong>Progress</strong></h6></div>            
              </div>   
              <div className="row">                
                <div className='col-sm-4 mt-35'>
                  <Field
                    name="ProgressAllTargets"
                    label="All targets maintained at 80% or above"
                    disabled={true}
                    component={renderCheckBox}
                  />
                </div>
                <div className='col-sm-4 mt-35'>
                  <Field
                    name="ProgressMostTargets"
                    label="Most targets maintained at 80% or above"
                    disabled={true}
                    component={renderCheckBox}
                  />
                </div>
                <div className='col-sm-4 mt-35'>
                  <Field
                    name="ProgressMultipleTargets"
                    label="Multiple targets did not maintain at 80% or above"
                    disabled={true}
                    component={renderCheckBox}
                  />
                </div>                       
                <div className='col-sm-4 mt-35'>
                  <Field
                    name="ProgressOtherTargets"
                    label="Other"
                    disabled={true}
                    component={renderCheckBox}
                  />
                </div>
                {this.props.selectorProgressOtherTargets &&
                (<div className='col-sm-4 require'>
                  <Field
                    name="ProgressOtherTargetsNotes"
                    type="text"
                    fullWidth={true}
                    label="Other Notes"
                    disabled={true}
                    component={renderTextField}
                  />
                </div>)}
              </div>
              
              <div className="row">
                <div className="col-sm-12">
                  <div className="panel_title">
                    <h5>Summary of Maladaptive Behaviors </h5><span style={{ color: 'red' }}>*</span>                    
                  </div>
                </div>
              </div>
              <div className="row mt-35">               
                <div className="col-sm-12"><h6><strong>Behavior Reduction Techniques</strong></h6></div>            
              </div>   
              <div className="row">                
                <div className='col-sm-4 mt-35'>
                  <Field
                    name="DifferentialReinforcement"
                    label="Differential reinforcement"
                    disabled={true}
                    component={renderCheckBox}
                  />
                </div>
                <div className='col-sm-4 mt-35'>
                  <Field
                    name="Extinction"
                    label="Extinction"
                    disabled={true}
                    component={renderCheckBox}
                  />
                </div>
                <div className='col-sm-4 mt-35'>
                  <Field
                    name="BehavioralMomentum"
                    label="Behavioral momentum"
                    disabled={true}
                    component={renderCheckBox}
                  />
                </div>
                <div className='col-sm-4 mt-35'>
                  <Field
                    name="FCT"
                    label="FCT"
                    disabled={true}
                    component={renderCheckBox}
                  />
                </div>
                <div className='col-sm-4 mt-35'>
                  <Field
                    name="Assessment"
                    label="Assessment/Observation"
                    disabled={true}
                    component={renderCheckBox}
                  />
                </div>     
                <div className='col-sm-4 mt-35'>
                  <Field
                    name="OperantReinforcement"
                    label="Operant reinforcement"
                    disabled={true}
                    component={renderCheckBox}
                  />
                </div>    
                <div className='col-sm-4 mt-35'>
                  <Field
                    name="AntecedentManipulations"
                    label="Antecedent manipulations"
                    disabled={true}
                    component={renderCheckBox}
                  />
                </div>
                <div className='col-sm-4 mt-35'>
                  <Field
                    name="TaskAnalysis"
                    label="Task Analysis"
                    disabled={true}
                    component={renderCheckBox}
                  />
                </div>
                <div className='col-sm-4 mt-35'>
                  <Field
                    name="PositiveReinforcement"
                    label="Positive reinforcement"
                    disabled={true}
                    component={renderCheckBox}
                  />
                </div>     
                <div className='col-sm-4 mt-35'>
                  <Field
                    name="Punishment"
                    label="Punishment"
                    disabled={true}
                    component={renderCheckBox}
                  />
                </div>                
                <div className='col-sm-4 mt-35'>
                  <Field
                    name="OtherBR"
                    label="Other"
                    disabled={true}
                    component={renderCheckBox}
                  />
                </div>
                {this.props.selectorOtherBR &&
                (<div className='col-sm-4 require'>
                  <Field
                    name="OtherBRNotes"
                    type="text"
                    fullWidth={true}
                    label="Other Notes"
                    disabled={true}
                    component={renderTextField}
                  />
                </div>)}
              </div>

              <div className="row">
                <div className="col-sm-12">
                  <div className="panel_title">
                    <h5>Protocol Modification by BCBA/BCaBA (only)</h5>
                  </div>
                </div>
              </div>
              <div className="row">                
                <div className='col-sm-4 mt-35'>
                  <Field
                    name="DataAnalysis"
                    label="Data Analysis/graphing"
                    disabled={true}
                    component={renderCheckBox}
                  />
                </div>
                <div className='col-sm-4 mt-35'>
                  <Field
                    name="UpdatedBIP"
                    label="Updated BIP"
                    disabled={true}
                    component={renderCheckBox}
                  />
                </div>
                <div className='col-sm-4 mt-35'>
                  <Field
                    name="AssessmentPM"
                    label="Assessment/FBA"
                    disabled={true}
                    component={renderCheckBox}
                  />
                </div>
                <div className='col-sm-4 mt-35'>
                  <Field
                    name="ModificationsToCurrentProgramming"
                    label="Modifications to current programming"
                    disabled={true}
                    component={renderCheckBox}
                  />
                </div>
                <div className='col-sm-4 mt-35'>
                  <Field
                    name="DevelopNewProgramming"
                    label="Develop new programming"
                    disabled={true}
                    component={renderCheckBox}
                  />
                </div>                            
                <div className='col-sm-4 mt-35'>
                  <Field
                    name="OtherPM"
                    label="Other"
                    disabled={true}
                    component={renderCheckBox}
                  />
                </div>
                {this.props.selectorOtherPM &&
                (<div className='col-sm-4 require'>
                  <Field
                    name="OtherPMNotes"
                    type="text"
                    fullWidth={true}
                    label="Other Notes"
                    disabled={true}
                    component={renderTextField}
                  />
                </div>)}
              </div>
              
              <div className="row">
                <div className="col-sm-12">
                  <div className="panel_title">
                    <h5>BT Guidance by BCBA/BCaBA (only)</h5>
                  </div>
                </div>
              </div>
              <div className="row">                
                <div className='col-sm-4 mt-35'>
                  <Field
                    name="AccuracyOfDataCollection"
                    label="Accuracy of data collection"
                    disabled={true}
                    component={renderCheckBox}
                  />
                </div>
                <div className='col-sm-4 mt-35'>
                  <Field
                    name="EffectivelyImplementsDTT"
                    label="Effectively implements DTT"
                    disabled={true}
                    component={renderCheckBox}
                  />
                </div>
                <div className='col-sm-4 mt-35'>
                  <Field
                    name="EffectivelyImplementsClientBIP"
                    label="Effectively implements client BIP"
                    disabled={true}
                    component={renderCheckBox}
                  />
                </div>
                <div className='col-sm-4 mt-35'>
                  <Field
                    name="EffectivelyImplementsErrorCorrection"
                    label="Effectively implements Error Correction"
                    disabled={true}
                    component={renderCheckBox}
                  />
                </div>
                <div className='col-sm-4 mt-35'>
                  <Field
                    name="EffectivelyImplementsSystematicPromptFading"
                    label="Effectively implements systematic prompt fading"
                    disabled={true}
                    component={renderCheckBox}
                  />
                </div>     
                <div className='col-sm-4 mt-35'>
                  <Field
                    name="EffectivelyEstablishesInstructionalControl"
                    label="Effectively establishes instructional control"
                    disabled={true}
                    component={renderCheckBox}
                  />
                </div>     
                <div className='col-sm-4 mt-35'>
                  <Field
                    name="ImplementsReinforcementProceduresEffectively"
                    label="Implements reinforcement procedures effectively"
                    disabled={true}
                    component={renderCheckBox}
                  />
                </div>                            
                <div className='col-sm-4 mt-35'>
                  <Field
                    name="OtherBT"
                    label="Other"
                    disabled={true}
                    component={renderCheckBox}
                  />
                </div>
                {this.props.selectorOtherBT &&
                (<div className='col-sm-4 require'>
                  <Field
                    name="OtherBTNotes"
                    type="text"
                    fullWidth={true}
                    label="Other Notes"
                    disabled={true}
                    component={renderTextField}
                  />
                </div>)}
              </div>
              

              <div className="row">
                <div className='col-sm-12 require'>
                  <Field
                    name="notes"
                    type="text"
                    fullWidth={true}
                    label="Summary Statement"
                    // autoHeight={true}
                    rows={8}
                    disabled={true}
                    component={renderTextArea}
                  />
                </div>
              </div>
            
              <div className = "row">
                <div className="col-sm-12">
                  <div className="panel_title mt-24  mb-20">
                    <h3>Diagnosis</h3>
                    <i className="flaticon flaticon-gym"></i>
                  </div>
                </div>
              </div>
              <div className="table-responsive mt-15">
                <Table className={tableClass1}
                  height={this.state.height}
                  fixedHeader={this.state.fixedHeader}
                  fixedFooter={this.state.fixedFooter}
                  selectable={this.state.selectable}
                  multiSelectable={this.state.multiSelectable}
                >
                  <TableHeader
                    displaySelectAll={false}
                    adjustForCheckbox={false}
                  >
                    <TableRow>
                      <TableHeaderColumn width="30%">Diagnosis Code</TableHeaderColumn>
                      <TableHeaderColumn width="70%">Description</TableHeaderColumn>
                    </TableRow>
                  </TableHeader>
                  <TableBody
                    displayRowCheckbox={false}
                    deselectOnClickaway={this.state.deselectOnClickaway}
                    showRowHover={this.state.showRowHover}
                    stripedRows={this.state.stripedRows}
                  >
                    {this.renderDiagnosis()}
                  </TableBody>
                </Table>
              </div>
              <div className = "row">
                <div className="col-sm-12">
                  <div className="panel_title mt-24  mb-20">
                    <h3>Service Codes</h3>
                    <i className="flaticon flaticon-interface-2"></i>
                  </div>
                </div>
              </div>
              <div className="table-responsive mt-15">
                <Table className={tableClass1}
                  height={this.state.height}
                  fixedHeader={this.state.fixedHeader}
                  fixedFooter={this.state.fixedFooter}
                  selectable={this.state.selectable}
                  multiSelectable={this.state.multiSelectable}
                >
                  <TableHeader
                    displaySelectAll={false}
                    adjustForCheckbox={false}
                  >
                    <TableRow>
                      <TableHeaderColumn width="20%">Service Code</TableHeaderColumn>
                      <TableHeaderColumn width="30%">Modifiers</TableHeaderColumn>
                      <TableHeaderColumn width="50%">Description</TableHeaderColumn>
                    </TableRow>
                  </TableHeader>
                  <TableBody
                    displayRowCheckbox={false}
                    deselectOnClickaway={this.state.deselectOnClickaway}
                    showRowHover={this.state.showRowHover}
                    stripedRows={this.state.stripedRows}
                  >
                    {this.renderCpt()}
                  </TableBody>
                </Table>
              </div>
              { this.state.EmployeeSign.Bytes || this.state.ClientSign.Bytes || this.state.GuardianSign.Bytes || this.state.RenderingProviderSign.Bytes ?
                <div className="row">
                  <div className="col-12">
                    <div className="panel_title mt-24  mb-20">
                      <h3>Signature</h3>
                      <i className="flaticon flaticon-medical-1"></i>
                    </div>
                  </div>
                  {
                    this.state.EmployeeSign.Bytes ?
                      <div className="col-sm-12 col-md-4">
                        <div id="showCanvasImageEmployee">

                          <div className="row">
                            <div className="col-12">
                              <div className="sign">
                                <img className="img-fluid" src={`data:image/png;base64,${this.state.EmployeeSign.Bytes}`} alt={''} />
                                <h3>{this.state.EmployeeSign.Name} <span>(Employee)</span></h3>
                                <p><span>Date :</span> {showFormatedDateandTime(this.state.EmployeeSign.Date)}</p>
                                {/* <p><span>Latitude :</span> {this.state.EmployeeSign.Latitude}</p>
                                <p><span>Longitude :</span> {this.state.EmployeeSign.Longitude}</p> */}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      : ''
                  }
                  {this.state.ClientSign.Bytes ?
                    <div className="col-sm-12 col-md-4">
                      <div id="showCanvasImageClient">
                        <div className="row">
                          <div className="col-12">
                            <div className="sign">
                              <img className="img-fluid" src={`data:image/png;base64,${this.state.ClientSign.Bytes}`} alt={''} />
                              <h3>{this.state.ClientSign.Name} <span>(Client)</span></h3>
                              <p><span>Date :</span> {showFormatedDateandTime(this.state.ClientSign.Date)}</p>
                              {/* <p><span>Latitude :</span> {this.state.ClientSign.Latitude}</p>
                              <p><span>Longitude :</span> {this.state.ClientSign.Longitude}</p> */}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    : ''
                  }
                  {this.state.GuardianSign.Bytes ?
                    <div className="col-sm-12 col-md-4">
                      <div id="showCanvasImageGuadian">

                        <div className="row">
                          <div className="col-12">
                            <div className="sign">
                              <img className="img-fluid" src={`data:image/png;base64,${this.state.GuardianSign.Bytes}`} alt={''} />
                              <h3>{this.state.GuardianSign.Name} <span>(Guardian)</span></h3>
                              <p><span>Date :</span> {showFormatedDateandTime(this.state.GuardianSign.Date)}</p>
                              {/* <p><span>Latitude :</span> {this.state.GuardianSign.Latitude}</p>
                              <p><span>Longitude :</span> {this.state.GuardianSign.Longitude}</p> */}
                            </div>
                          </div>
                        </div>

                      </div>
                    </div>
                    : ''
                  }
                  {
                  this.state.RenderingProviderSign.Bytes ?
                    <div className="col-sm-12 col-md-4">
                      <div id="showCanvasImageEmployee">

                        <div className="row">
                          <div className="col-12">
                            <div className="sign">
                              <img className="img-fluid" src={`data:image/png;base64,${this.state.RenderingProviderSign.Bytes}`} alt={''} />
                              <h3>{this.state.RenderingProviderSign.Name} <span>(Supervising Clinician)</span></h3>
                              <p><span>Date :</span> {showFormatedDateandTime(this.state.RenderingProviderSign.Date)}</p>
                              {/* <p><span>Latitude :</span> {this.state.RenderingProviderSign.Latitude}</p>
                              <p><span>Longitude :</span> {this.state.RenderingProviderSign.Longitude}</p> */}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    : ''
                }
                </div>
                : ''}
            </form>
          </div>
        </div>
      </div>
    );
  }
}
const selector = formValueSelector('EncounterForm');
EncounterForm = reduxForm({
  form: 'EncounterForm',
  enableReinitialize: true,
})(EncounterForm);
function mapStateToProps(state) {
  let initialData = {};
  let appointmentTime = null;
  if (state.patient.singleEncounter && state.patient.singleEncounter) {
    if (state.patient.singleEncounter.progressNotes_CAS) {       
      
        initialData['notes'] = state.patient.singleEncounter.progressNotes_CAS.notes; 

        // progressNote_ParentReport_CAS
        initialData['Happy'] = state.patient.singleEncounter.progressNotes_CAS.progressNote_ParentReport_CAS.happy;
        initialData['Tired'] = state.patient.singleEncounter.progressNotes_CAS.progressNote_ParentReport_CAS.tired; 
        initialData['Sick'] = state.patient.singleEncounter.progressNotes_CAS.progressNote_ParentReport_CAS.sick; 
        initialData['Wellrested'] = state.patient.singleEncounter.progressNotes_CAS.progressNote_ParentReport_CAS.wellrested; 
        initialData['Sensorysicking'] = state.patient.singleEncounter.progressNotes_CAS.progressNote_ParentReport_CAS.sensorysicking; 
        initialData['Upset'] = state.patient.singleEncounter.progressNotes_CAS.progressNote_ParentReport_CAS.upset; 
        initialData['OtherPN'] = state.patient.singleEncounter.progressNotes_CAS.progressNote_ParentReport_CAS.otherPN; 
        initialData['OtherPNNotes'] = state.patient.singleEncounter.progressNotes_CAS.progressNote_ParentReport_CAS.otherPNNotes; 

        initialData['IsWarrantTherapy'] = state.patient.singleEncounter.progressNotes_CAS.progressNote_ParentReport_CAS.isWarrantTherapy || 0; 
        
        // progressNote_SymptomsObserved_CAS
        initialData['SkillDeftReceptiveLanguage'] = state.patient.singleEncounter.progressNotes_CAS.progressNote_SymptomsObserved_CAS.skillDeftReceptiveLanguage; 
        initialData['SkillDeftAdaptiveBehavior'] = state.patient.singleEncounter.progressNotes_CAS.progressNote_SymptomsObserved_CAS.skillDeftAdaptiveBehavior; 
        initialData['SkillDeftExpressiveLanguage'] = state.patient.singleEncounter.progressNotes_CAS.progressNote_SymptomsObserved_CAS.skillDeftExpressiveLanguage; 
        initialData['SkillDeftImitationSkills'] = state.patient.singleEncounter.progressNotes_CAS.progressNote_SymptomsObserved_CAS.skillDeftImitationSkills; 
        initialData['SkillDeftSocialSkills'] = state.patient.singleEncounter.progressNotes_CAS.progressNote_SymptomsObserved_CAS.skillDeftSocialSkills; 
        initialData['SkillDeftCommunitySafetySkills'] = state.patient.singleEncounter.progressNotes_CAS.progressNote_SymptomsObserved_CAS.skillDeftCommunitySafetySkills; 
        initialData['SkillDeftPlaySkills'] = state.patient.singleEncounter.progressNotes_CAS.progressNote_SymptomsObserved_CAS.skillDeftPlaySkills; 
        initialData['SkillDeftOther'] = state.patient.singleEncounter.progressNotes_CAS.progressNote_SymptomsObserved_CAS.skillDeftOther; 
        initialData['SkillDeftOtherNotes'] = state.patient.singleEncounter.progressNotes_CAS.progressNote_SymptomsObserved_CAS.skillDeftOtherNotes;
 
        initialData['TechBehSampling'] = state.patient.singleEncounter.progressNotes_CAS.progressNote_SymptomsObserved_CAS.techBehSampling; 
        initialData['TechBehBehavioralSkillsTraining'] = state.patient.singleEncounter.progressNotes_CAS.progressNote_SymptomsObserved_CAS.techBehBehavioralSkillsTraining; 
        initialData['TechBehDTT'] = state.patient.singleEncounter.progressNotes_CAS.progressNote_SymptomsObserved_CAS.techBehDTT; 
        initialData['TechBehShaping'] = state.patient.singleEncounter.progressNotes_CAS.progressNote_SymptomsObserved_CAS.techBehShaping; 
        initialData['TechBehErrorlessTeaching'] = state.patient.singleEncounter.progressNotes_CAS.progressNote_SymptomsObserved_CAS.techBehErrorlessTeaching; 
        initialData['TechBehSystematicPromptFading'] = state.patient.singleEncounter.progressNotes_CAS.progressNote_SymptomsObserved_CAS.techBehSystematicPromptFading; 
        initialData['TechBehNET'] = state.patient.singleEncounter.progressNotes_CAS.progressNote_SymptomsObserved_CAS.techBehNET; 
        initialData['TechBehOther'] = state.patient.singleEncounter.progressNotes_CAS.progressNote_SymptomsObserved_CAS.techBehOther; 
        initialData['TechBehOtherNotes'] = state.patient.singleEncounter.progressNotes_CAS.progressNote_SymptomsObserved_CAS.techBehOtherNotes;

        // ProgressNote_TreatmentGoals_CAS
        initialData['SessionComments1'] = state.patient.singleEncounter.progressNotes_CAS.progressNote_TreatmentGoals_CAS.sessionComments1; 
        initialData['SessionMastery1'] = state.patient.singleEncounter.progressNotes_CAS.progressNote_TreatmentGoals_CAS.sessionMastery1; 
        initialData['ContinueTeaching1'] = state.patient.singleEncounter.progressNotes_CAS.progressNote_TreatmentGoals_CAS.continueTeaching1; 
        initialData['Generalized1'] = state.patient.singleEncounter.progressNotes_CAS.progressNote_TreatmentGoals_CAS.generalized1; 
        initialData['Hold1'] = state.patient.singleEncounter.progressNotes_CAS.progressNote_TreatmentGoals_CAS.hold1; 
        initialData['DevelopProtocol1'] = state.patient.singleEncounter.progressNotes_CAS.progressNote_TreatmentGoals_CAS.developProtocol1;        
        initialData['OtherTG1'] = state.patient.singleEncounter.progressNotes_CAS.progressNote_TreatmentGoals_CAS.otherTG1; 
        initialData['OtherTGNotes1'] = state.patient.singleEncounter.progressNotes_CAS.progressNote_TreatmentGoals_CAS.otherTGNotes1; 


        initialData['SessionComments2'] = state.patient.singleEncounter.progressNotes_CAS.progressNote_TreatmentGoals_CAS.sessionComments2; 
        initialData['SessionMastery2'] = state.patient.singleEncounter.progressNotes_CAS.progressNote_TreatmentGoals_CAS.sessionMastery2; 
        initialData['ContinueTeaching2'] = state.patient.singleEncounter.progressNotes_CAS.progressNote_TreatmentGoals_CAS.continueTeaching2; 
        initialData['Generalized2'] = state.patient.singleEncounter.progressNotes_CAS.progressNote_TreatmentGoals_CAS.generalized2; 
        initialData['Hold2'] = state.patient.singleEncounter.progressNotes_CAS.progressNote_TreatmentGoals_CAS.hold2; 
        initialData['DevelopProtocol2'] = state.patient.singleEncounter.progressNotes_CAS.progressNote_TreatmentGoals_CAS.developProtocol2;        
        initialData['OtherTG2'] = state.patient.singleEncounter.progressNotes_CAS.progressNote_TreatmentGoals_CAS.otherTG2; 
        initialData['OtherTGNotes2'] = state.patient.singleEncounter.progressNotes_CAS.progressNote_TreatmentGoals_CAS.otherTGNotes2; 


        initialData['SessionComments3'] = state.patient.singleEncounter.progressNotes_CAS.progressNote_TreatmentGoals_CAS.sessionComments3; 
        initialData['SessionMastery3'] = state.patient.singleEncounter.progressNotes_CAS.progressNote_TreatmentGoals_CAS.sessionMastery3; 
        initialData['ContinueTeaching3'] = state.patient.singleEncounter.progressNotes_CAS.progressNote_TreatmentGoals_CAS.continueTeaching3; 
        initialData['Generalized3'] = state.patient.singleEncounter.progressNotes_CAS.progressNote_TreatmentGoals_CAS.generalized3; 
        initialData['Hold3'] = state.patient.singleEncounter.progressNotes_CAS.progressNote_TreatmentGoals_CAS.hold3; 
        initialData['DevelopProtocol3'] = state.patient.singleEncounter.progressNotes_CAS.progressNote_TreatmentGoals_CAS.developProtocol3;        
        initialData['OtherTG3'] = state.patient.singleEncounter.progressNotes_CAS.progressNote_TreatmentGoals_CAS.otherTG3; 
        initialData['OtherTGNotes3'] = state.patient.singleEncounter.progressNotes_CAS.progressNote_TreatmentGoals_CAS.otherTGNotes3; 

        // ProgressNote_Generalization_CAS
        initialData['GenReceptiveLanguage'] = state.patient.singleEncounter.progressNotes_CAS.progressNote_Generalization_CAS.genReceptiveLanguage; 
        initialData['GenPlay'] = state.patient.singleEncounter.progressNotes_CAS.progressNote_Generalization_CAS.genPlay; 
        initialData['GenExpressiveLanguage'] = state.patient.singleEncounter.progressNotes_CAS.progressNote_Generalization_CAS.genExpressiveLanguage; 
        initialData['GenFCT'] = state.patient.singleEncounter.progressNotes_CAS.progressNote_Generalization_CAS.genFCT; 
        initialData['GenImitation'] = state.patient.singleEncounter.progressNotes_CAS.progressNote_Generalization_CAS.genImitation; 
        initialData['GenAdaptiveBehavior'] = state.patient.singleEncounter.progressNotes_CAS.progressNote_Generalization_CAS.genAdaptiveBehavior;      
        initialData['GenOther'] = state.patient.singleEncounter.progressNotes_CAS.progressNote_Generalization_CAS.genOther; 
        initialData['GenOtherNotes'] = state.patient.singleEncounter.progressNotes_CAS.progressNote_Generalization_CAS.genOtherNotes; 


        initialData['ProgressAllTargets'] = state.patient.singleEncounter.progressNotes_CAS.progressNote_Generalization_CAS.progressAllTargets; 
        initialData['ProgressMostTargets'] = state.patient.singleEncounter.progressNotes_CAS.progressNote_Generalization_CAS.progressMostTargets; 
        initialData['ProgressMultipleTargets'] = state.patient.singleEncounter.progressNotes_CAS.progressNote_Generalization_CAS.progressMultipleTargets;       
        initialData['ProgressOtherTargets'] = state.patient.singleEncounter.progressNotes_CAS.progressNote_Generalization_CAS.progressOtherTargets; 
        initialData['ProgressOtherTargetsNotes'] = state.patient.singleEncounter.progressNotes_CAS.progressNote_Generalization_CAS.progressOtherTargetsNotes; 

        initialData['TotalNumberOfTrials'] = state.patient.singleEncounter.progressNotes_CAS.progressNote_Generalization_CAS.totalNumberOfTrials; 

        // progressNote_BehaviorReduction_CAS
        initialData['DifferentialReinforcement'] = state.patient.singleEncounter.progressNotes_CAS.progressNote_BehaviorReduction_CAS.differentialReinforcement; 
        initialData['Extinction'] = state.patient.singleEncounter.progressNotes_CAS.progressNote_BehaviorReduction_CAS.extinction; 
        initialData['BehavioralMomentum'] = state.patient.singleEncounter.progressNotes_CAS.progressNote_BehaviorReduction_CAS.behavioralMomentum; 
        initialData['FCT'] = state.patient.singleEncounter.progressNotes_CAS.progressNote_BehaviorReduction_CAS.fct; 
        initialData['Assessment'] = state.patient.singleEncounter.progressNotes_CAS.progressNote_BehaviorReduction_CAS.assessment;        
        initialData['OperantReinforcement'] = state.patient.singleEncounter.progressNotes_CAS.progressNote_BehaviorReduction_CAS.operantReinforcement; 
        initialData['AntecedentManipulations'] = state.patient.singleEncounter.progressNotes_CAS.progressNote_BehaviorReduction_CAS.antecedentManipulations; 
        initialData['TaskAnalysis'] = state.patient.singleEncounter.progressNotes_CAS.progressNote_BehaviorReduction_CAS.taskAnalysis; 
        initialData['PositiveReinforcement'] = state.patient.singleEncounter.progressNotes_CAS.progressNote_BehaviorReduction_CAS.positiveReinforcement; 
        initialData['Punishment'] = state.patient.singleEncounter.progressNotes_CAS.progressNote_BehaviorReduction_CAS.punishment;
        initialData['OtherBR'] = state.patient.singleEncounter.progressNotes_CAS.progressNote_BehaviorReduction_CAS.otherBR; 
        initialData['OtherBRNotes'] = state.patient.singleEncounter.progressNotes_CAS.progressNote_BehaviorReduction_CAS.otherBRNotes;


         // progressNote_ProtocolModification_CAS
         initialData['DataAnalysis'] = state.patient.singleEncounter.progressNotes_CAS.progressNote_ProtocolModification_CAS.dataAnalysis; 
         initialData['UpdatedBIP'] = state.patient.singleEncounter.progressNotes_CAS.progressNote_ProtocolModification_CAS.updatedBIP; 
         initialData['AssessmentPM'] = state.patient.singleEncounter.progressNotes_CAS.progressNote_ProtocolModification_CAS.assessmentPM; 
         initialData['ModificationsToCurrentProgramming'] = state.patient.singleEncounter.progressNotes_CAS.progressNote_ProtocolModification_CAS.modificationsToCurrentProgramming; 
         initialData['DevelopNewProgramming'] = state.patient.singleEncounter.progressNotes_CAS.progressNote_ProtocolModification_CAS.developNewProgramming;
         initialData['OtherPM'] = state.patient.singleEncounter.progressNotes_CAS.progressNote_ProtocolModification_CAS.otherPM; 
         initialData['OtherPMNotes'] = state.patient.singleEncounter.progressNotes_CAS.progressNote_ProtocolModification_CAS.otherPMNotes; 


          // progressNote_BTGuidance_CAS
        initialData['AccuracyOfDataCollection'] = state.patient.singleEncounter.progressNotes_CAS.progressNote_BTGuidance_CAS.accuracyOfDataCollection; 
        initialData['EffectivelyImplementsDTT'] = state.patient.singleEncounter.progressNotes_CAS.progressNote_BTGuidance_CAS.effectivelyImplementsDTT; 
        initialData['EffectivelyImplementsClientBIP'] = state.patient.singleEncounter.progressNotes_CAS.progressNote_BTGuidance_CAS.effectivelyImplementsClientBIP; 
        initialData['EffectivelyImplementsErrorCorrection'] = state.patient.singleEncounter.progressNotes_CAS.progressNote_BTGuidance_CAS.effectivelyImplementsErrorCorrection; 
        initialData['EffectivelyImplementsSystematicPromptFading'] = state.patient.singleEncounter.progressNotes_CAS.progressNote_BTGuidance_CAS.effectivelyImplementsSystematicPromptFading; 
        initialData['EffectivelyEstablishesInstructionalControl'] = state.patient.singleEncounter.progressNotes_CAS.progressNote_BTGuidance_CAS.effectivelyEstablishesInstructionalControl; 
        initialData['ImplementsReinforcementProceduresEffectively'] = state.patient.singleEncounter.progressNotes_CAS.progressNote_BTGuidance_CAS.implementsReinforcementProceduresEffectively; 
        initialData['OtherBT'] = state.patient.singleEncounter.progressNotes_CAS.progressNote_BTGuidance_CAS.otherBT; 
        initialData['OtherBTNotes'] = state.patient.singleEncounter.progressNotes_CAS.progressNote_BTGuidance_CAS.otherBTNotes; 
    }
    if (state.patient.singleEncounter.patientEncounterDiagnosisCodes) {
      initialData['diagnosisArray'] = state.patient.singleEncounter.patientEncounterDiagnosisCodes;
    }
    if (state.patient.singleEncounter.patientEncounterServiceCodes) {
      initialData['CPTTableData'] = state.patient.singleEncounter.patientEncounterServiceCodes;
    }

    // if(state.patient.singleEncounter.appointmentStartDateTime){
    //   let startTimehours = state.patient.singleEncounter.appointmentStartDateTime.substr(11, 2);
    //   let endTimehours = state.patient.singleEncounter.appointmentEndDateTime.substr(11, 2);
    //   let formattedStartTimehours = parseInt(startTimehours, 10) >= 12 ?
    //     (parseInt(startTimehours, 10) - 12 < 10 ?
    //       `0${parseInt(startTimehours, 10) - 12}`
    //       : startTimehours)
    //     : startTimehours;
    //   let formattedEndTimehours = parseInt(endTimehours, 10) >= 12 ? (parseInt(endTimehours, 10) - 12 < 10 ? `0${parseInt(endTimehours, 10) - 12}` : endTimehours) : endTimehours;
    //   let AmPmOfStartTime = parseInt(startTimehours, 10) >= 12 ? 'pm' : 'am';
    //   let AmPmOfEndTime = parseInt(endTimehours, 10) >= 12 ? 'pm' : 'am';
    //   appointmentTime = `${formattedStartTimehours}:${state.patient.singleEncounter.appointmentStartDateTime.substr(14, 2)} ${AmPmOfStartTime} - ${formattedEndTimehours}:${state.patient.singleEncounter.appointmentEndDateTime.substr(14, 2)} ${AmPmOfEndTime}`;
    //   initialData['appointmentTime'] = appointmentTime;
    // }

    // console.log('state.patient.singleEncounter.............', state.patient.singleEncounter);

    if (state.patient.singleEncounter.startDateTime) {
      let startTimehours = state.patient.singleEncounter.startDateTime.substr(11, 2);
      let endTimehours = state.patient.singleEncounter.endDateTime.substr(11, 2);
      let formattedStartTimehours = parseInt(startTimehours, 10) >= 12 ? (parseInt(startTimehours, 10) - 12 < 10 ? `0${parseInt(startTimehours, 10) - 12}` : startTimehours) : startTimehours;
      let formattedEndTimehours = parseInt(endTimehours, 10) >= 12 ? (parseInt(endTimehours, 10) - 12 < 10 ? `0${parseInt(endTimehours, 10) - 12}` : endTimehours) : endTimehours;

      let AmPmOfStartTime = parseInt(startTimehours, 10) >= 12 ? 'pm' : 'am';
      let AmPmOfEndTime = parseInt(endTimehours, 10) >= 12 ? 'pm' : 'am';
      appointmentTime = `${formattedStartTimehours}:${state.patient.singleEncounter.startDateTime.substr(14, 2)} ${AmPmOfStartTime} - ${formattedEndTimehours}:${state.patient.singleEncounter.endDateTime.substr(14, 2)} ${AmPmOfEndTime}`;
      initialData['appointmentTime'] = appointmentTime;
    }


    initialData['locationName'] = state.patient.singleEncounter.locationName;
    initialData['staffName'] = state.patient.singleEncounter.staffName;
    initialData['appointmentDate'] = state.patient.singleEncounter.patientAppointment.startDateTime;
    initialData['PatientLocationName'] = state.patient.singleEncounter.PatientLocationName;
    initialData['serviceEndTime'] = moment(state.patient.singleEncounter.patientAppointment.endDateTime).format('YYYY-MM-DD') + 'T' + moment(state.patient.singleEncounter.patientAppointment.endDateTime).format('HH:mm:ss');
    initialData['serviceStartTime'] = moment(state.patient.singleEncounter.patientAppointment.startDateTime).format('YYYY-MM-DD') + 'T' + moment(state.patient.singleEncounter.patientAppointment.startDateTime).format('HH:mm:ss');

  }
  return {
    selectorOtherPN: selector(state, 'OtherPN'),
    selectorSkillDeftOther: selector(state, 'SkillDeftOther'),
    selectorTechBehOther: selector(state, 'TechBehOther'),
    selectorOtherTG1: selector(state, 'OtherTG1'),
    selectorOtherTG2: selector(state, 'OtherTG2'),
    selectorOtherTG3: selector(state, 'OtherTG3'),    
    selectorGenOther: selector(state, 'GenOther'),
    selectorProgressOtherTargets: selector(state, 'ProgressOtherTargets'),
    selectorOtherBR: selector(state, 'OtherBR'),
    selectorOtherPM: selector(state, 'OtherPM'),
    selectorOtherBT: selector(state, 'OtherBT'),

    singleEncounter: state.patient.singleEncounter,
    initialValues: initialData,
    IsWarrantTherapy: state.patient.singleEncounter && state.patient.singleEncounter.progressNotes_CAS ? state.patient.singleEncounter.progressNotes_CAS.progressNote_ParentReport_CAS.isWarrantTherapy ? 1 : 0 : 0,
  };
}
export default connect(mapStateToProps, { getPatientSingleEncounters })(EncounterForm);



// WEBPACK FOOTER //
// ./src/modules/patients/components/Encounter/ProgressNotes_Encounter_CAS.js